import dynamic from 'next/dynamic';

import { AlertProps } from './HotelAlerts.types';

export const HotelAlerts = dynamic<AlertProps>(() => import('./HotelAlerts').then(module => module.HotelAlerts));
